import { useHistory, useLocation } from 'react-router-dom';

export const useAppRouter = () => {
    const history = useHistory();
    const location = useLocation();
    const { push, replace, go, goBack, goForward, listen } = history;
    const { pathname, search, hash, state, key } = location;

    return {
        // raw objects — for cases that need to pass them as props
        history,
        location,
        // flat location properties — for convenient destructuring
        pathname,
        search,
        hash,
        state,
        key,
        // flat history actions — for convenient destructuring
        push,
        replace,
        go,
        goBack,
        goForward,
        listen
    };
};
